import React, { FunctionComponent } from 'react'
import { ViewStyle } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { BaseText } from '../../atoms/baseText/BaseText'
import { PressableOpacity } from '../../atoms/pressableOpacity/PressableOpacity'
import { AccessibilityRolesNative, IS_WEB } from '../../constants'
import { getFocusBoxShadow } from '../../styles/commonStyles'
import { DisplaySize, TextType } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'

export type ClientDetailsTabItemProps = {
  onTabPressed: () => void
  isActive: boolean
  tabDisplayName: string
  testID: string
  disabled?: boolean
}

const ClientDetailsTabItemContainer = styled.View({
  alignSelf: 'flex-start',
})

const NavItemButtonActiveUnderline = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  width: '100%',
  height: '3px',
  backgroundColor: theme.colors.backgroundActive,
  position: 'absolute',
  borderTopLeftRadius: theme.spacing['16px'],
  borderTopRightRadius: theme.spacing['16px'],
  left: 0,
  right: 0,
  bottom: 0,
  marginLeft: 'auto',
  marginRight: 'auto',
}))

const BaseTextContainer = styled(PressableOpacity)<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  ...(IS_WEB ? { cursor: 'pointer' } : {}),
  padding: `0 ${spacing['8px']}`,
  marginBottom: spacing['12px'],
  borderRadius: spacing['4px'],
}))

export const ClientDetailsTabItem: FunctionComponent<ClientDetailsTabItemProps> = ({
  tabDisplayName,
  isActive,
  onTabPressed,
  testID,
  disabled = false,
}) => {
  const { colors } = useTheme()

  const pressableStyle = {
    hoveredBackgroundColor: colors.secondaryTertiaryButtonBackgroundHover,
    pressedBackgroundColor: colors.tertiaryButtonBackgroundPressed,
    styleByState: (pressed: boolean, focusVisible: boolean) => {
      const style: ViewStyle = {}
      if (pressed) {
        style.boxShadow = getFocusBoxShadow({ colors, outerBoxShadowSize: '6px' }).boxShadow
        style.backgroundColor = colors.tertiaryButtonBackgroundPressed
      }
      if (focusVisible && !pressed) {
        style.backgroundColor = colors.tertiaryButtonBackgroundPressed
      }
      return style
    },
  }

  return (
    <ClientDetailsTabItemContainer>
      <BaseTextContainer testID={testID} onPress={onTabPressed} disabled={disabled} {...pressableStyle}>
        <BaseText
          role={AccessibilityRolesNative.TAB}
          color={isActive ? colors.textActive : colors.textPrimary}
          text={tabDisplayName}
          type={TextType.DISPLAY}
          size={DisplaySize.EYEBROW}
        />
      </BaseTextContainer>
      {isActive && <NavItemButtonActiveUnderline />}
    </ClientDetailsTabItemContainer>
  )
}
